import React from "react";
import { Card, Empty, Space, Typography } from "antd";
import { useTranslation } from "react-i18next";
import type { EventStatsData } from "../useEventStats";
import { formatAlcohol, formatVolume } from "./utils";

const { Text } = Typography;
type FeaturedEntry = NonNullable<EventStatsData["topBeerEntry"]>;

type FeaturedEntryCardProps = {
    entry: FeaturedEntry | null;
    titleKey: string;
    fallbackKey: string;
    emptyKey: string;
    keyPrefix: string;
};

const FeaturedEntryCard: React.FC<FeaturedEntryCardProps> = ({entry, titleKey, fallbackKey, emptyKey, keyPrefix}) => {
    const {t} = useTranslation();

    if (!entry) {
        return <Card title={t(titleKey)}><Empty description={t(emptyKey)} image={Empty.PRESENTED_IMAGE_SIMPLE} /></Card>;
    }

    return (
        <Card title={t(titleKey)}>
            <Space direction="vertical">
                <Text strong>{entry.label}</Text>
                <Text type="secondary">{t("eventStats.cards.totalLabel", {
                    volume: formatVolume(entry.totalVolumeMl),
                    alcohol: formatAlcohol(entry.totalAlcoholGrams),
                })}</Text>
                {!entry.matchedByKeyword && <Text type="secondary">{t(fallbackKey)}</Text>}
                {entry.participants.length > 0 ? (
                    <Space direction="vertical" size={0}>
                        <Text>{t("eventStats.cards.topDrinkersLabel")}</Text>
                        {entry.participants.slice(0, 5).map((participant, index) => (
                            <Text key={`${keyPrefix}-participant-${participant.userId}`}>
                                {index + 1}. {participant.username} · {formatVolume(participant.totalVolumeMl)} · {formatAlcohol(participant.totalAlcoholGrams)}
                            </Text>
                        ))}
                    </Space>
                ) : (
                    <Text type="secondary">{t("eventStats.cards.noTopConsumer")}</Text>
                )}
            </Space>
        </Card>
    );
};

export default FeaturedEntryCard;
